<template>
	<v-row class='fill-height'>
		<v-col cols='3'>
			<v-row no-gutters class='fill-height'>
				<v-col cols='12' class='text-center'>
					<div id='current-time' class='white--text'>
						<font-awesome-icon icon='clock'></font-awesome-icon>
						<current-time-display :general-information='generalInformation' />
					</div>
				</v-col>
				<v-col cols='12'>
					<v-row justify='center'>
						<v-col cols='auto'>
							<h1 class='white--text'>DRAWINGS</h1>
						</v-col>
					</v-row>
					<v-row justify='center'>
						<v-col v-for='sortition in generalInformation.sortedSortitions' cols='auto' :key='sortition.id'>
							<h2
								:class='{"red--text": generalInformation.sortition.id === sortition.id, "white--text": generalInformation.sortition.id !== sortition.id }'>
								{{ sortition.abbreviation }}
							</h2>
						</v-col>
					</v-row>
				</v-col>
				<v-col cols='12'>
					<v-card class='bg-transparent w-100 white--text prizes-card align-center d-flex h-100' rounded='xl'>
						<v-row no-gutters>
							<v-col cols='12'>
								<span class='prizes-title'>Prizes</span>
								<prizes-list class='font-weight-bold' :general-information='generalInformation'>
									<template #prize-row='{prize}'>
										<v-col class='prize-name' cols='6'>
											{{ prize.name }}
										</v-col>
										<v-col class='prize-amount' cols='6'>
											{{ prize.amount }}
										</v-col>
									</template>
								</prizes-list>
							</v-col>
						</v-row>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols='3' class='d-flex align-center'>
			<v-row no-gutters>
				<v-col cols='12' class='justify-center'>
					<v-img class='my-6' contain width='300' :src="require('@/assets/img/premierlotto/logo.png')" />
				</v-col>
				<v-col>
					<v-card class='bg-transparent white--text rounded-xl'>
						<countdown px-5 py-5 text-center :sortition='generalInformation.sortition' />
					</v-card>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols='6' class='d-flex align-center'>
			<v-row>
				<v-col cols='6' v-for='(result, index) in generalInformation.results.slice(0, 4)' :key='result.sortition.id'>
					<v-card class='bg-transparent white--text text-center fill-height rounded-xl'
									:class="{'last-winning': index === 0 }">
						<result-vertical-display :result='result'
																		 :image-dimensions='{height: 34, width: 34}'
																		 :pick-one-image='{src: require("@/assets/img/premierlotto/pickOne.png"), width: 160 }'
																		 :pick-two-image='{src: require("@/assets/img/premierlotto/pickTwo.png"), width: 160 }'
																		 :pick-three-image='{src: require("@/assets/img/premierlotto/pickThree.png"), width: 160 }'
																		 :pick-four-image='{src: require("@/assets/img/premierlotto/pickFour.png"), width: 160 }'
						/>
						<h5 v-if='index === 0'>LAST WINNING</h5>
					</v-card>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<script>
import Countdown from '@homepage/components/Countdown.vue';
import { generateImageMapFor } from '@homepage/helpers/image.js';
import PrizesList from '@homepage/components/PrizesList.vue';
import ResultVerticalDisplay from '@homepage/components/ResultVerticalDisplay.vue';
import CurrentTimeDisplay from '@homepage/components/CurrentTimeDisplay.vue';

export default {
	name: 'PremierLottoBoard',
	provide() {
		return {
			imagesMap: generateImageMapFor('quickmoney'),
			generalInformation: this.generalInformation
		};
	},
	props: {
		generalInformation: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			timeToShowResultsPage: 30000,
			timeToShowPrizesPage: 1000,
			timeToShowEachLotteryResultPage: 10000,
			lotteryEntriesPerPage: 2
		};
	},
	components: {
		CurrentTimeDisplay,
		ResultVerticalDisplay,
		PrizesList,
		Countdown
	},
	beforeCreate() {
		this.$emit('change-style', { backgroundImage: require('@/assets/img/premierlotto/background.jpg') });
	}
};
</script>
<style scoped>
.v-card {
	border: 4px solid white;
}

.v-card.bg-transparent {
	background-color: transparent !important;
}

.prizes-title {
	font-size: 300%;
	font-weight: bold;
}

.prize-name {
	font-size: 180%;
}

.prize-amount {
	font-size: 240%;
	font-weight: 800;
}

.prizes-card {
	text-align: center;
}

#current-time {
	font-size: 250%;
	font-weight: bold;
}

::v-deep .prize-item:nth-child(odd) {
	background-color: #5563a54f;
}
</style>

<style>
.lottery-result:nth-child(even) {
	background-color: #eaeaea;
}

@keyframes blink {
	from {
		border: 3px solid #b12B7A;
	}
	to {
		border: 3px solid white;
	}
}

.last-winning {
	transition: border;
	animation: blink 500ms infinite alternate ease;
}
</style>
